import type { Step } from "react-joyride";

export const documentEditTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າແກ້ໄຂເອກະສານ (ໃຊ້ໄດ້ເມື່ອສະຖານະຮ່າງເທົ່ານັ້ນ). ແກ້ໄຂລາຍລະອຽດ ແລະ ບັນທຶກການປ່ຽນແປງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="document-edit-back"]',
    content: "ກັບໄປຫນ້າລາຍລະອຽດເອກະສານໂດຍບໍ່ບັນທຶກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="document-edit-form"]',
    content:
      "ແກ້ໄຂລາຍລະອຽດລູກຄ້າ, ລາຍການ ຫຼື ການຕັ້ງຄ່າ ແລະ ກົດບັນທຶກເພື່ອອັບເດດເອກະສານ.",
    placement: "top",
  },
];
